module.exports = __webpack_public_path__ + "img/482908_894E0D_FBDB52_CA7420-256px.eeb2cbbf.png";